import * as React from "react";
const SvgMoon01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.196 6.307q.001-1.002.166-1.957A9.427 9.427 0 1 0 19.65 17.637q-.956.165-1.956.167c-6.35 0-11.497-5.148-11.497-11.497m2.07 0a9.427 9.427 0 0 0 9.427 9.426 9.4 9.4 0 0 0 3.88-.832 1.035 1.035 0 0 1 1.37 1.37 11.5 11.5 0 0 1-10.481 6.764c-6.35 0-11.497-5.147-11.497-11.497 0-4.664 2.778-8.678 6.764-10.481a1.035 1.035 0 0 1 1.37 1.37 9.4 9.4 0 0 0-.832 3.88"
}));
export default SvgMoon01;
//# sourceMappingURL=Moon01.js.map